import { SVGProps, Ref, forwardRef } from 'react';

export const ChevronGroup1FilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="M8 3c0 .986.004 1.614.082 2.19A9.2 9.2 0 0 0 12.718 12a9.2 9.2 0 0 0-4.636 6.81C8.004 19.388 8 20.015 8 21h2.4c0-1.021.007-1.474.06-1.87a6.8 6.8 0 0 1 4.019-5.327c.359-.157.581-.285 1.521-.555v-2.496c-.94-.27-1.162-.398-1.521-.555A6.8 6.8 0 0 1 10.46 4.87c-.053-.396-.06-.849-.06-1.87z"
                fill="currentColor"
            />
        </g>
    </svg>
));
ChevronGroup1FilledSize24Glyph.displayName = 'ChevronGroup1FilledSize24Glyph';
